var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 115,
    viewBox: "0 0 132 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.22838 10.425C8.11594 10.425 10.4568 8.09121 10.4568 5.21245C10.4568 2.33368 8.11594 0 5.22838 0C2.34082 0 0 2.33368 0 5.21245C0 8.09121 2.34082 10.425 5.22838 10.425Z",
    fill: "url(#paint0_linear_58_138)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.22838 10.425C8.11594 10.425 10.4568 8.09121 10.4568 5.21245C10.4568 2.33368 8.11594 0 5.22838 0C2.34082 0 0 2.33368 0 5.21245C0 8.09121 2.34082 10.425 5.22838 10.425Z",
    fill: "url(#paint1_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 11,
    height: 11
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.5095 10.425C38.397 10.425 40.7378 8.09121 40.7378 5.21245C40.7378 2.33368 38.397 0 35.5095 0C32.6219 0 30.2811 2.33368 30.2811 5.21245C30.2811 8.09121 32.6219 10.425 35.5095 10.425Z",
    fill: "url(#paint2_linear_58_138)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.5095 10.425C38.397 10.425 40.7378 8.09121 40.7378 5.21245C40.7378 2.33368 38.397 0 35.5095 0C32.6219 0 30.2811 2.33368 30.2811 5.21245C30.2811 8.09121 32.6219 10.425 35.5095 10.425Z",
    fill: "url(#paint3_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 0,
    width: 12,
    height: 11
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M65.7905 10.425C68.6781 10.425 71.0189 8.09121 71.0189 5.21245C71.0189 2.33368 68.6781 0 65.7905 0C62.903 0 60.5621 2.33368 60.5621 5.21245C60.5621 8.09121 62.903 10.425 65.7905 10.425Z",
    fill: "url(#paint4_linear_58_138)"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M65.7905 10.425C68.6781 10.425 71.0189 8.09121 71.0189 5.21245C71.0189 2.33368 68.6781 0 65.7905 0C62.903 0 60.5621 2.33368 60.5621 5.21245C60.5621 8.09121 62.903 10.425 65.7905 10.425Z",
    fill: "url(#paint5_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 0,
    width: 12,
    height: 11
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M96.0716 10.425C98.9592 10.425 101.3 8.09121 101.3 5.21245C101.3 2.33368 98.9592 0 96.0716 0C93.184 0 90.8432 2.33368 90.8432 5.21245C90.8432 8.09121 93.184 10.425 96.0716 10.425Z",
    fill: "url(#paint6_linear_58_138)"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M96.0716 10.425C98.9592 10.425 101.3 8.09121 101.3 5.21245C101.3 2.33368 98.9592 0 96.0716 0C93.184 0 90.8432 2.33368 90.8432 5.21245C90.8432 8.09121 93.184 10.425 96.0716 10.425Z",
    fill: "url(#paint7_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 0,
    width: 11,
    height: 11
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M126.353 10.425C129.24 10.425 131.581 8.09121 131.581 5.21245C131.581 2.33368 129.24 0 126.353 0C123.465 0 121.124 2.33368 121.124 5.21245C121.124 8.09121 123.465 10.425 126.353 10.425Z",
    fill: "url(#paint8_linear_58_138)"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M126.353 10.425C129.24 10.425 131.581 8.09121 131.581 5.21245C131.581 2.33368 129.24 0 126.353 0C123.465 0 121.124 2.33368 121.124 5.21245C121.124 8.09121 123.465 10.425 126.353 10.425Z",
    fill: "url(#paint9_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 11,
    height: 11
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M5.22838 36.5958C8.11594 36.5958 10.4568 34.2621 10.4568 31.3833C10.4568 28.5046 8.11594 26.1709 5.22838 26.1709C2.34082 26.1709 0 28.5046 0 31.3833C0 34.2621 2.34082 36.5958 5.22838 36.5958Z",
    fill: "url(#paint10_linear_58_138)"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M5.22838 36.5958C8.11594 36.5958 10.4568 34.2621 10.4568 31.3833C10.4568 28.5046 8.11594 26.1709 5.22838 26.1709C2.34082 26.1709 0 28.5046 0 31.3833C0 34.2621 2.34082 36.5958 5.22838 36.5958Z",
    fill: "url(#paint11_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 26,
    width: 11,
    height: 11
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M35.5095 36.5958C38.397 36.5958 40.7378 34.2621 40.7378 31.3833C40.7378 28.5046 38.397 26.1709 35.5095 26.1709C32.6219 26.1709 30.2811 28.5046 30.2811 31.3833C30.2811 34.2621 32.6219 36.5958 35.5095 36.5958Z",
    fill: "url(#paint12_linear_58_138)"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M35.5095 36.5958C38.397 36.5958 40.7378 34.2621 40.7378 31.3833C40.7378 28.5046 38.397 26.1709 35.5095 26.1709C32.6219 26.1709 30.2811 28.5046 30.2811 31.3833C30.2811 34.2621 32.6219 36.5958 35.5095 36.5958Z",
    fill: "url(#paint13_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 26,
    width: 12,
    height: 11
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M65.7905 36.5958C68.6781 36.5958 71.0189 34.2621 71.0189 31.3833C71.0189 28.5046 68.6781 26.1709 65.7905 26.1709C62.903 26.1709 60.5621 28.5046 60.5621 31.3833C60.5621 34.2621 62.903 36.5958 65.7905 36.5958Z",
    fill: "url(#paint14_linear_58_138)"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M65.7905 36.5958C68.6781 36.5958 71.0189 34.2621 71.0189 31.3833C71.0189 28.5046 68.6781 26.1709 65.7905 26.1709C62.903 26.1709 60.5621 28.5046 60.5621 31.3833C60.5621 34.2621 62.903 36.5958 65.7905 36.5958Z",
    fill: "url(#paint15_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 26,
    width: 12,
    height: 11
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M96.0716 36.5958C98.9592 36.5958 101.3 34.2621 101.3 31.3833C101.3 28.5046 98.9592 26.1709 96.0716 26.1709C93.184 26.1709 90.8432 28.5046 90.8432 31.3833C90.8432 34.2621 93.184 36.5958 96.0716 36.5958Z",
    fill: "url(#paint16_linear_58_138)"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M96.0716 36.5958C98.9592 36.5958 101.3 34.2621 101.3 31.3833C101.3 28.5046 98.9592 26.1709 96.0716 26.1709C93.184 26.1709 90.8432 28.5046 90.8432 31.3833C90.8432 34.2621 93.184 36.5958 96.0716 36.5958Z",
    fill: "url(#paint17_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 26,
    width: 11,
    height: 11
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M126.353 36.5958C129.24 36.5958 131.581 34.2621 131.581 31.3833C131.581 28.5046 129.24 26.1709 126.353 26.1709C123.465 26.1709 121.124 28.5046 121.124 31.3833C121.124 34.2621 123.465 36.5958 126.353 36.5958Z",
    fill: "url(#paint18_linear_58_138)"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M126.353 36.5958C129.24 36.5958 131.581 34.2621 131.581 31.3833C131.581 28.5046 129.24 26.1709 126.353 26.1709C123.465 26.1709 121.124 28.5046 121.124 31.3833C121.124 34.2621 123.465 36.5958 126.353 36.5958Z",
    fill: "url(#paint19_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 52,
    width: 11,
    height: 11
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M5.22838 62.7126C8.11594 62.7126 10.4568 60.3789 10.4568 57.5001C10.4568 54.6213 8.11594 52.2876 5.22838 52.2876C2.34082 52.2876 0 54.6213 0 57.5001C0 60.3789 2.34082 62.7126 5.22838 62.7126Z",
    fill: "url(#paint20_linear_58_138)"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M5.22838 62.7126C8.11594 62.7126 10.4568 60.3789 10.4568 57.5001C10.4568 54.6213 8.11594 52.2876 5.22838 52.2876C2.34082 52.2876 0 54.6213 0 57.5001C0 60.3789 2.34082 62.7126 5.22838 62.7126Z",
    fill: "url(#paint21_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 52,
    width: 11,
    height: 11
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M35.5095 62.7126C38.397 62.7126 40.7378 60.3789 40.7378 57.5001C40.7378 54.6213 38.397 52.2876 35.5095 52.2876C32.6219 52.2876 30.2811 54.6213 30.2811 57.5001C30.2811 60.3789 32.6219 62.7126 35.5095 62.7126Z",
    fill: "url(#paint22_linear_58_138)"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M35.5095 62.7126C38.397 62.7126 40.7378 60.3789 40.7378 57.5001C40.7378 54.6213 38.397 52.2876 35.5095 52.2876C32.6219 52.2876 30.2811 54.6213 30.2811 57.5001C30.2811 60.3789 32.6219 62.7126 35.5095 62.7126Z",
    fill: "url(#paint23_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 52,
    width: 12,
    height: 11
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M65.7905 62.7126C68.6781 62.7126 71.0189 60.3789 71.0189 57.5001C71.0189 54.6213 68.6781 52.2876 65.7905 52.2876C62.903 52.2876 60.5621 54.6213 60.5621 57.5001C60.5621 60.3789 62.903 62.7126 65.7905 62.7126Z",
    fill: "url(#paint24_linear_58_138)"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M65.7905 62.7126C68.6781 62.7126 71.0189 60.3789 71.0189 57.5001C71.0189 54.6213 68.6781 52.2876 65.7905 52.2876C62.903 52.2876 60.5621 54.6213 60.5621 57.5001C60.5621 60.3789 62.903 62.7126 65.7905 62.7126Z",
    fill: "url(#paint25_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 52,
    width: 12,
    height: 11
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M96.0716 62.7126C98.9592 62.7126 101.3 60.3789 101.3 57.5001C101.3 54.6213 98.9592 52.2876 96.0716 52.2876C93.184 52.2876 90.8432 54.6213 90.8432 57.5001C90.8432 60.3789 93.184 62.7126 96.0716 62.7126Z",
    fill: "url(#paint26_linear_58_138)"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M96.0716 62.7126C98.9592 62.7126 101.3 60.3789 101.3 57.5001C101.3 54.6213 98.9592 52.2876 96.0716 52.2876C93.184 52.2876 90.8432 54.6213 90.8432 57.5001C90.8432 60.3789 93.184 62.7126 96.0716 62.7126Z",
    fill: "url(#paint27_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 52,
    width: 11,
    height: 11
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M126.353 62.7126C129.24 62.7126 131.581 60.3789 131.581 57.5001C131.581 54.6213 129.24 52.2876 126.353 52.2876C123.465 52.2876 121.124 54.6213 121.124 57.5001C121.124 60.3789 123.465 62.7126 126.353 62.7126Z",
    fill: "url(#paint28_linear_58_138)"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M126.353 62.7126C129.24 62.7126 131.581 60.3789 131.581 57.5001C131.581 54.6213 129.24 52.2876 126.353 52.2876C123.465 52.2876 121.124 54.6213 121.124 57.5001C121.124 60.3789 123.465 62.7126 126.353 62.7126Z",
    fill: "url(#paint29_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 78,
    width: 11,
    height: 11
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M5.22838 88.8835C8.11594 88.8835 10.4568 86.5497 10.4568 83.6709C10.4568 80.7922 8.11594 78.4585 5.22838 78.4585C2.34082 78.4585 0 80.7922 0 83.6709C0 86.5497 2.34082 88.8835 5.22838 88.8835Z",
    fill: "url(#paint30_linear_58_138)"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M5.22838 88.8835C8.11594 88.8835 10.4568 86.5497 10.4568 83.6709C10.4568 80.7922 8.11594 78.4585 5.22838 78.4585C2.34082 78.4585 0 80.7922 0 83.6709C0 86.5497 2.34082 88.8835 5.22838 88.8835Z",
    fill: "url(#paint31_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 78,
    width: 11,
    height: 11
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M35.5095 88.8835C38.397 88.8835 40.7378 86.5497 40.7378 83.6709C40.7378 80.7922 38.397 78.4585 35.5095 78.4585C32.6219 78.4585 30.2811 80.7922 30.2811 83.6709C30.2811 86.5497 32.6219 88.8835 35.5095 88.8835Z",
    fill: "url(#paint32_linear_58_138)"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M35.5095 88.8835C38.397 88.8835 40.7378 86.5497 40.7378 83.6709C40.7378 80.7922 38.397 78.4585 35.5095 78.4585C32.6219 78.4585 30.2811 80.7922 30.2811 83.6709C30.2811 86.5497 32.6219 88.8835 35.5095 88.8835Z",
    fill: "url(#paint33_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 78,
    width: 12,
    height: 11
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M65.7905 88.8835C68.6781 88.8835 71.0189 86.5497 71.0189 83.6709C71.0189 80.7922 68.6781 78.4585 65.7905 78.4585C62.903 78.4585 60.5621 80.7922 60.5621 83.6709C60.5621 86.5497 62.903 88.8835 65.7905 88.8835Z",
    fill: "url(#paint34_linear_58_138)"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M65.7905 88.8835C68.6781 88.8835 71.0189 86.5497 71.0189 83.6709C71.0189 80.7922 68.6781 78.4585 65.7905 78.4585C62.903 78.4585 60.5621 80.7922 60.5621 83.6709C60.5621 86.5497 62.903 88.8835 65.7905 88.8835Z",
    fill: "url(#paint35_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 78,
    width: 12,
    height: 11
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M96.0716 88.8835C98.9592 88.8835 101.3 86.5497 101.3 83.6709C101.3 80.7922 98.9592 78.4585 96.0716 78.4585C93.184 78.4585 90.8432 80.7922 90.8432 83.6709C90.8432 86.5497 93.184 88.8835 96.0716 88.8835Z",
    fill: "url(#paint36_linear_58_138)"
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M96.0716 88.8835C98.9592 88.8835 101.3 86.5497 101.3 83.6709C101.3 80.7922 98.9592 78.4585 96.0716 78.4585C93.184 78.4585 90.8432 80.7922 90.8432 83.6709C90.8432 86.5497 93.184 88.8835 96.0716 88.8835Z",
    fill: "url(#paint37_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 78,
    width: 11,
    height: 11
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M126.353 88.8835C129.24 88.8835 131.581 86.5497 131.581 83.6709C131.581 80.7922 129.24 78.4585 126.353 78.4585C123.465 78.4585 121.124 80.7922 121.124 83.6709C121.124 86.5497 123.465 88.8835 126.353 88.8835Z",
    fill: "url(#paint38_linear_58_138)"
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M126.353 88.8835C129.24 88.8835 131.581 86.5497 131.581 83.6709C131.581 80.7922 129.24 78.4585 126.353 78.4585C123.465 78.4585 121.124 80.7922 121.124 83.6709C121.124 86.5497 123.465 88.8835 126.353 88.8835Z",
    fill: "url(#paint39_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 104,
    width: 11,
    height: 11
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M5.22838 115C8.11594 115 10.4568 112.666 10.4568 109.787C10.4568 106.909 8.11594 104.575 5.22838 104.575C2.34082 104.575 0 106.909 0 109.787C0 112.666 2.34082 115 5.22838 115Z",
    fill: "url(#paint40_linear_58_138)"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M5.22838 115C8.11594 115 10.4568 112.666 10.4568 109.787C10.4568 106.909 8.11594 104.575 5.22838 104.575C2.34082 104.575 0 106.909 0 109.787C0 112.666 2.34082 115 5.22838 115Z",
    fill: "url(#paint41_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 104,
    width: 11,
    height: 11
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M35.5095 115C38.397 115 40.7378 112.666 40.7378 109.787C40.7378 106.909 38.397 104.575 35.5095 104.575C32.6219 104.575 30.2811 106.909 30.2811 109.787C30.2811 112.666 32.6219 115 35.5095 115Z",
    fill: "url(#paint42_linear_58_138)"
  }))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M35.5095 115C38.397 115 40.7378 112.666 40.7378 109.787C40.7378 106.909 38.397 104.575 35.5095 104.575C32.6219 104.575 30.2811 106.909 30.2811 109.787C30.2811 112.666 32.6219 115 35.5095 115Z",
    fill: "url(#paint43_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 104,
    width: 12,
    height: 11
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M65.7905 115C68.6781 115 71.0189 112.666 71.0189 109.787C71.0189 106.909 68.6781 104.575 65.7905 104.575C62.903 104.575 60.5621 106.909 60.5621 109.787C60.5621 112.666 62.903 115 65.7905 115Z",
    fill: "url(#paint44_linear_58_138)"
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M65.7905 115C68.6781 115 71.0189 112.666 71.0189 109.787C71.0189 106.909 68.6781 104.575 65.7905 104.575C62.903 104.575 60.5621 106.909 60.5621 109.787C60.5621 112.666 62.903 115 65.7905 115Z",
    fill: "url(#paint45_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 104,
    width: 12,
    height: 11
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M96.0716 115C98.9592 115 101.3 112.666 101.3 109.787C101.3 106.909 98.9592 104.575 96.0716 104.575C93.184 104.575 90.8432 106.909 90.8432 109.787C90.8432 112.666 93.184 115 96.0716 115Z",
    fill: "url(#paint46_linear_58_138)"
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M96.0716 115C98.9592 115 101.3 112.666 101.3 109.787C101.3 106.909 98.9592 104.575 96.0716 104.575C93.184 104.575 90.8432 106.909 90.8432 109.787C90.8432 112.666 93.184 115 96.0716 115Z",
    fill: "url(#paint47_linear_58_138)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_58_138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 104,
    width: 11,
    height: 11
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID 213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M126.353 115C129.24 115 131.581 112.666 131.581 109.787C131.581 106.909 129.24 104.575 126.353 104.575C123.465 104.575 121.124 106.909 121.124 109.787C121.124 112.666 123.465 115 126.353 115Z",
    fill: "url(#paint48_linear_58_138)"
  }))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_58_138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M126.353 115C129.24 115 131.581 112.666 131.581 109.787C131.581 106.909 129.24 104.575 126.353 104.575C123.465 104.575 121.124 106.909 121.124 109.787C121.124 112.666 123.465 115 126.353 115Z",
    fill: "url(#paint49_linear_58_138)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_138",
    x1: 54.996,
    y1: 131.134,
    x2: -16.4057,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_138",
    x1: 54.996,
    y1: 131.134,
    x2: -16.4057,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_138",
    x1: 85.2771,
    y1: 131.134,
    x2: 13.8755,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_138",
    x1: 85.2771,
    y1: 131.134,
    x2: 13.8755,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_58_138",
    x1: 115.558,
    y1: 131.134,
    x2: 44.1566,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_58_138",
    x1: 115.558,
    y1: 131.134,
    x2: 44.1566,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_58_138",
    x1: 145.839,
    y1: 131.134,
    x2: 74.4376,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_58_138",
    x1: 145.839,
    y1: 131.134,
    x2: 74.4376,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_58_138",
    x1: 176.12,
    y1: 131.134,
    x2: 104.719,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_58_138",
    x1: 176.12,
    y1: 131.134,
    x2: 104.719,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_58_138",
    x1: 54.996,
    y1: 157.303,
    x2: -16.4045,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_58_138",
    x1: 54.996,
    y1: 157.303,
    x2: -16.4045,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_58_138",
    x1: 85.2771,
    y1: 157.303,
    x2: 13.8767,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_58_138",
    x1: 85.2771,
    y1: 157.303,
    x2: 13.8767,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_58_138",
    x1: 115.558,
    y1: 157.303,
    x2: 44.1578,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_58_138",
    x1: 115.558,
    y1: 157.303,
    x2: 44.1578,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_58_138",
    x1: 145.839,
    y1: 157.303,
    x2: 74.4389,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_58_138",
    x1: 145.839,
    y1: 157.303,
    x2: 74.4389,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_58_138",
    x1: 176.12,
    y1: 157.303,
    x2: 104.72,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_58_138",
    x1: 176.12,
    y1: 157.303,
    x2: 104.72,
    y2: -24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_58_138",
    x1: 54.996,
    y1: 183.421,
    x2: -16.4057,
    y2: 1.61761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_58_138",
    x1: 54.996,
    y1: 183.421,
    x2: -16.4057,
    y2: 1.61761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_58_138",
    x1: 85.2771,
    y1: 183.421,
    x2: 13.8755,
    y2: 1.61756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_58_138",
    x1: 85.2771,
    y1: 183.421,
    x2: 13.8755,
    y2: 1.61756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_58_138",
    x1: 115.558,
    y1: 183.421,
    x2: 44.1566,
    y2: 1.61756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_58_138",
    x1: 115.558,
    y1: 183.421,
    x2: 44.1566,
    y2: 1.61756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_58_138",
    x1: 145.839,
    y1: 183.421,
    x2: 74.4376,
    y2: 1.61756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_58_138",
    x1: 145.839,
    y1: 183.421,
    x2: 74.4376,
    y2: 1.61756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_58_138",
    x1: 176.12,
    y1: 183.421,
    x2: 104.719,
    y2: 1.61756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_58_138",
    x1: 176.12,
    y1: 183.421,
    x2: 104.719,
    y2: 1.61756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_58_138",
    x1: 54.996,
    y1: 209.592,
    x2: -16.4057,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_58_138",
    x1: 54.996,
    y1: 209.592,
    x2: -16.4057,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_58_138",
    x1: 85.2771,
    y1: 209.592,
    x2: 13.8755,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_58_138",
    x1: 85.2771,
    y1: 209.592,
    x2: 13.8755,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_58_138",
    x1: 115.558,
    y1: 209.592,
    x2: 44.1566,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_58_138",
    x1: 115.558,
    y1: 209.592,
    x2: 44.1566,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_58_138",
    x1: 145.839,
    y1: 209.592,
    x2: 74.4376,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_58_138",
    x1: 145.839,
    y1: 209.592,
    x2: 74.4376,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_58_138",
    x1: 176.12,
    y1: 209.592,
    x2: 104.719,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_58_138",
    x1: 176.12,
    y1: 209.592,
    x2: 104.719,
    y2: 27.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_58_138",
    x1: 54.996,
    y1: 235.709,
    x2: -16.4057,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_58_138",
    x1: 54.996,
    y1: 235.709,
    x2: -16.4057,
    y2: 53.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_58_138",
    x1: 85.2771,
    y1: 235.709,
    x2: 13.8755,
    y2: 53.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_58_138",
    x1: 85.2771,
    y1: 235.709,
    x2: 13.8755,
    y2: 53.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_58_138",
    x1: 115.558,
    y1: 235.709,
    x2: 44.1566,
    y2: 53.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_58_138",
    x1: 115.558,
    y1: 235.709,
    x2: 44.1566,
    y2: 53.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_58_138",
    x1: 145.839,
    y1: 235.709,
    x2: 74.4376,
    y2: 53.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_58_138",
    x1: 145.839,
    y1: 235.709,
    x2: 74.4376,
    y2: 53.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_58_138",
    x1: 176.12,
    y1: 235.709,
    x2: 104.719,
    y2: 53.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_58_138",
    x1: 176.12,
    y1: 235.709,
    x2: 104.719,
    y2: 53.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsWhite);
export default __webpack_public_path__ + "static/media/dots_white.ff1b2c76cf7df8f69480e88cb6b3cd51.svg";
export { ForwardRef as ReactComponent };